import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import Loader from '../components/Loader/Loader';
import { useImpersonation } from '../auth/ImpersonationContext';

const SSO_BASE_URL = import.meta.env.VITE_SSO_AUTHORITY;

export const Route = createFileRoute('/impersonation/start')({
  validateSearch: (search: Record<string, unknown>) => ({
    itk: (search.itk as string) ?? '',
  }),
  component: ImpersonationStartPage,
});

function ImpersonationStartPage() {
  const { itk } = Route.useSearch();
  const navigate = useNavigate();
  const { save } = useImpersonation();
  const started = useRef(false);

  useEffect(() => {
    if (!itk || started.current) return;
    started.current = true;

    const acceptUrl =
      `${SSO_BASE_URL}/api/impersonate/accept` +
      `?itk=${encodeURIComponent(itk)}` +
      `&origin=${encodeURIComponent(window.location.origin)}`;

    const popup = window.open(acceptUrl, '_blank', 'width=600,height=400');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== SSO_BASE_URL) return;
      if (!event.data || event.data.type !== 'IMPERSONATION_TOKEN') return;

      window.removeEventListener('message', messageHandler);
      popup?.close();

      const tokens = JSON.parse(event.data.tokens as string) as {
        id_token: string;
        access_token: string;
      };
      save(
        tokens.id_token,
        tokens.access_token,
        event.data.exp as number,
        event.data.subject as string,
      );
      navigate({ to: '/', replace: true });
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [itk, save, navigate]);

  return <Loader fullScreen />;
}
